import {AuthUserPermissions, AuthUserPermissionsFeature} from './types'
import {PermissionKey} from '../users/types'
import {TKey} from '@/translations/i18n'

export const permissionKeysMap = {
    accesses: {
        read: PermissionKey.enum.can_view_accesses,
        write: PermissionKey.enum.can_write_accesses
    },
    agenda: {
        read: PermissionKey.enum.can_view_agenda,
        write: PermissionKey.enum.can_write_agenda
    },
    patients: {
        read: PermissionKey.enum.can_view_patients,
        write: PermissionKey.enum.can_write_patients
    },
    medicalRecords: {
        read: PermissionKey.enum.can_view_medical_records,
        write: PermissionKey.enum.can_write_medical_records
    },
    requests: {
        read: PermissionKey.enum.can_view_treatment_requests,
        write: PermissionKey.enum.can_write_treatment_requests
    },
    projects: {
        read: PermissionKey.enum.can_view_projects,
        write: PermissionKey.enum.can_write_projects
    },
    conversations: {
        read: PermissionKey.enum.can_view_messages,
        write: PermissionKey.enum.can_write_messages
    },
    settings: {
        read: PermissionKey.enum.can_view_settings,
        write: PermissionKey.enum.can_write_settings
    },
    users: {
        read: PermissionKey.enum.can_view_users,
        write: PermissionKey.enum.can_write_users
    },
    eventStatus: {
        read: PermissionKey.enum.can_view_event_status,
        write: PermissionKey.enum.can_write_event_status
    },
    // Single-key permission: the BE exposes one `can_send_mail` flag for both
    // read and write (see star-be user.resource sendMail section).
    sendMail: {
        read: PermissionKey.enum.can_send_mail,
        write: PermissionKey.enum.can_send_mail
    }
} as const satisfies Record<
    AuthUserPermissionsFeature,
    {
        read: PermissionKey
        write: PermissionKey
    }
>

export const authPermissionsToPermissionKeys = (authPermissions: AuthUserPermissions): PermissionKey[] => {
    const permissionKeys: PermissionKey[] = []

    AuthUserPermissionsFeature.options.forEach(feature => {
        if (authPermissions[feature]?.read && !permissionKeys.includes(permissionKeysMap[feature].read)) {
            permissionKeys.push(permissionKeysMap[feature].read)
        }
        if (authPermissions[feature]?.write && !permissionKeys.includes(permissionKeysMap[feature].write)) {
            permissionKeys.push(permissionKeysMap[feature].write)
        }
    })

    return permissionKeys
}

export const authPermissionsFeatureToLabel = {
    [AuthUserPermissionsFeature.enum.accesses]: 'accesses:title',
    [AuthUserPermissionsFeature.enum.agenda]: 'agenda:title',
    [AuthUserPermissionsFeature.enum.patients]: 'commons:patients',
    [AuthUserPermissionsFeature.enum.medicalRecords]: 'commons:medical_records',
    [AuthUserPermissionsFeature.enum.requests]: 'commons:treatment_requests',
    [AuthUserPermissionsFeature.enum.projects]: 'commons:projects',
    [AuthUserPermissionsFeature.enum.conversations]: 'conversations:title',
    [AuthUserPermissionsFeature.enum.settings]: 'commons:settings',
    [AuthUserPermissionsFeature.enum.users]: 'commons:users',
    [AuthUserPermissionsFeature.enum.eventStatus]: 'agenda:event_status',
    [AuthUserPermissionsFeature.enum.sendMail]: 'mailer:title'
} as const satisfies Record<AuthUserPermissionsFeature, TKey>
